import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../../layout";
import { Button, InputSwitch } from "../../../controls";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import {
  ClearRounded,
  EditRounded,
  LockResetRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatDate, ToFormData } from "../../../hooks";
import { AppContext } from "../../../App";
import { API, action, controller } from "../../../api/api";
import { toast } from "react-toastify";
import ResetPasswordForm from "./Form/ResetPasswordForm";

const Users = () => {
  const navigate = useNavigate();
  const { selOutlet, setLoader, access } = useContext(AppContext);
  const [users, setUsers] = useState([]);
  const [updateUserId, setUpdateUserId] = useState();
  const [showResetPassForm, setShowResetPassForm] = useState(false);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const handleAddEdit = (id) => {
    navigate(`/user_form/${id || ""}`);
  };

  useEffect(() => {
    setLoader(true);
    API(controller.User + action.GetAllByOrg).get((res) => {
      res && res.status === 200 && setUsers([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selOutlet]);

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure!",
      subTitle: "You want to delete this user?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setUsers((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.User).Delete(id, onComplete);
      },
    });
  };

  const handleShowResetPassForm = (id) => {
    setUpdateUserId(id);
    setShowResetPassForm(true);
  };

  const ActionComp = (props) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      {access?.user?.passwordReset && (
        <Tooltip arrow title={"Reset Password"}>
          <IconButton
            onClick={() => handleShowResetPassForm(props.id)}
            size="small"
            color="primary"
          >
            <LockResetRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.user?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(props.id)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.user?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(props.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}{" "}
    </div>
  );

  const HeaderComp = () =>
    access?.user?.create && (
      <Button onClick={() => handleAddEdit()}>Add User</Button>
    );

  const handleActive = (id) => {
    API(controller.User + action.ChangeStatus).post(
      ToFormData({
        userId: id,
        dateTime: new Date().toISOString(),
      }),
      (res) => {
        res && res.status === 200
          ? setUsers([
              ...users.map((j) =>
                j.id === id ? { ...j, isActive: res.result.isActive } : j
              ),
            ])
          : toast.error(res?.msg);
      }
    );
  };

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "actions", label: "Actions" },
          { id: "user", label: "User" },
          { id: "active", label: "active" },
          { id: "access", label: "Access" },
          { id: "contact", label: "Contact" },
        ]}
        tblData={users.map((j) => {
          return {
            ...j,
            active: access?.user?.edit ? (
              <InputSwitch
                checked={j.isActive}
                onChange={() => handleActive(j.id)}
              />
            ) : j.isActive ? (
              "Yes"
            ) : (
              "No"
            ),
            user: (
              <div className="flex mt-[5px] mb-[5px]">
                <div className="mr-[20px]">
                  <Avatar src={j.photo} className="shadow-lg" />
                </div>
                <div className="grid">
                  <span className="font-medium mb-[3px]">{j.fullName}</span>
                  <div className="text-[12px]">
                    <span className="uppercase font-bold">Last Visit</span> :{" "}
                    <span className="font-bold">{formatDate(j.lastVisit)}</span>
                  </div>
                </div>
              </div>
            ),
            access: (
              <div className="grid">
                <span className="text-[16px] font-medium text-gray-500 cursor-pointer">
                  {j.username}
                </span>
                <span className="text-[12px] font-medium text-gray-500 cursor-pointer">
                  {j.role?.title} |{" "}
                  {j.outletPermissions
                    .map((x) => x.outlet && x.outlet.outletName)
                    .join(", ")}
                </span>
              </div>
            ),
            contact: (
              <div className="grid">
                <a
                  className="text-[14px] primary-color cursor-pointer mb-[3px]"
                  href={`mailto:${j.email}`}
                >
                  ✉️ {j.email}
                </a>
                <a
                  className="text-[14px] primary-color cursor-pointer"
                  href={`tel:${j.phone}`}
                >
                  📞 {j.phone}
                </a>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Change Access */}
      {updateUserId && (
        <Dialog show={showResetPassForm} onClose={false} maxWidth="xs">
          <ResetPasswordForm
            key={showResetPassForm ? new Date() : "hidden"}
            userId={updateUserId}
            setShowForm={setShowResetPassForm}
          />
        </Dialog>
      )}
    </>
  );
};

export default Users;
